import React from 'react';
import './UpdateComponent.css';

const UpdateComponent = ({ onUpdateSelected, onDeleteSelected }) => {
  return (
    <div className="update-action-row">
      {onUpdateSelected && <button type="button" className="btn" onClick={onUpdateSelected}>Update Selected</button>}
      {onDeleteSelected && <button type="button" className="btn" onClick={onDeleteSelected}>Delete Selected</button>}
    </div>
  );
};

export default UpdateComponent;
